const tr = {
  action: {
    new: 'Novo',
    show: 'Exibir',
    edit: 'Editar',
    delete: 'Excluir',
    filter: 'Filtrar',
    filters: 'Filtros',
    cancel: 'Cancelar',
    save: 'Salvar',
    atention: 'Atenção',
    active: 'Ativar',
    deactivate: 'Desativar',
    remove: 'Remover',
    search: 'Buscar',
    erase: 'Apagar',
    import: 'Importar',
    downloadTemplate: 'Baixar modelo',
    importSpreadsheet: 'Importar Planilha',
    importSreadsheetLabel: 'Importe a planilha no formato .xlsx',
    instructions: 'Instruções',
    hide: 'Ocultar',
    loading: 'Carregando...',
    actions: 'Ações',
    download: 'Baixar',
    downloading: 'Baixando...',
    back: 'Voltar',
    save_success: 'Salvo com sucesso',
    export_csv: 'CSV',
    export_xlsx: 'XLSX',
    export: 'Exportar',
    acceptDocs: 'Aceitar Documentos',
    rejectDocs: 'Rejeitar Documentos'
  },
};

export default tr;
